"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiesco": {
    "fd2b6255": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "skipSearch": false
    }],
    "campazzo": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65c55a99": [{
      "hkey": "18f89061",
      "slug": "cascina-abbadia",
      "name": "Cascina Abbadia",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-abbadia-santa-marta": [{
      "hkey": "18f89061",
      "slug": "cascina-abbadia",
      "name": "Cascina Abbadia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d941aa45": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "skipSearch": false
    }],
    "giacinta": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67a103d5": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "skipSearch": false
    }],
    "mirasole": [{
      "hkey": "35e700c2",
      "slug": "fiesco",
      "name": "Fiesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;